import React from 'react';
import { Container, Text, Heading } from '@chakra-ui/react';

const CreateNavigation = () => {
  return (
    <Container maxW="container.lg" py={6}>
      <Heading size="lg" mb={4}>Create Navigation</Heading>
      <Text>Create navigation form coming soon...</Text>
    </Container>
  );
};

export default CreateNavigation;